import PrtvInterface1Component from './components/prtv-interface-1/prtv-interface-1.component';
import PrtvInterface2Component from './components/prtv-interface-2/prtv-interface-2.component';
import PrtvInterface3Component from './components/prtv-interface-3/prtv-interface-3.component';
import PrtvInterface4Component from './components/prtv-interface-4/prtv-interface-4.component';
import PrtvInterface5Component from './components/prtv-interface-5/prtv-interface-5.component';
import PrtvInterface6Component from './components/prtv-interface-6/prtv-interface-6.component';
import PrtvDepotFactureComponent from './components/prtv-depot-facture/prtv-depot-facture.component';
import PrtvDepotFacture2Component from './components/prtv-depot-facture-2/prtv-depot-facture-2.component';
import PrtvDepotFacture3Component from './components/prtv-depot-facture-3/prtv-depot-facture-3.component';
import typePerturbateurFilter from './filters/type-perturbateur.filter';
import ouiNonFilter from '../common/filters/oui-non.filter';
import labelCiviliteFilter from '../base/filters/civilite.filter';

import routerConfig from './routes';

require('./prtv.scss');

const moduleName = 'dmattnt-prtv';
angular.module(moduleName, ['ui.router'])
  .component('dmattntPrtvInterface1', new PrtvInterface1Component())
  .component('dmattntPrtvInterface2', new PrtvInterface2Component())
  .component('dmattntPrtvInterface3', new PrtvInterface3Component())
  .component('dmattntPrtvInterface4', new PrtvInterface4Component())
  .component('dmattntPrtvInterface5', new PrtvInterface5Component())
  .component('dmattntPrtvInterface6', new PrtvInterface6Component())
  .component('dmattntPrtvDepotFacture', new PrtvDepotFactureComponent())
  .component('dmattntPrtvDepotFacture2', new PrtvDepotFacture2Component())
  .component('dmattntPrtvDepotFacture3', new PrtvDepotFacture3Component())
  .filter('labelTypePerturbateur', typePerturbateurFilter)
  .filter('labelOuiNon', ouiNonFilter)
  .filter('labelCivilite', labelCiviliteFilter)
  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/prtv/prtv.module.js